module.exports = __webpack_public_path__ + "static/media/background10.0bd812a6.png";